/**
 * Cut-paper shapes behind a parchment band — the same soft cream, gold and
 * sage blobs the hero journey animation uses, so the light bands read as part
 * of one set. Decorative only: aria-hidden, pointer-events off, clipped to the
 * section. `flip` mirrors them so two light bands in a row do not look stamped.
 */
export default function PaperShapes({ flip = false }: { flip?: boolean }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      <span
        className={`absolute -top-44 h-[520px] w-[520px] bg-[#E6D7B2] opacity-70 ${flip ? '-left-44' : '-right-44'}`}
        style={{ borderRadius: '46% 54% 42% 58% / 52% 40% 60% 48%' }}
      />
      <span
        className={`absolute -top-20 h-[300px] w-[300px] bg-[#D9C08A] opacity-50 ${flip ? '-left-16' : '-right-16'}`}
        style={{ borderRadius: '58% 42% 50% 50% / 44% 56% 44% 56%' }}
      />
      <span
        className={`absolute -bottom-56 h-[480px] w-[520px] bg-[#DCE0CF] opacity-80 ${flip ? '-right-44' : '-left-44'}`}
        style={{ borderRadius: '52% 48% 60% 40% / 50% 58% 42% 50%' }}
      />
    </div>
  );
}
